import commonModel from './common';
import paCheckModel from './paCheck';

const storeModel = {
  common: commonModel,
  paCheck: paCheckModel,
};

export default storeModel;
